import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import datePickerMessages from './DatePicker';

var messages = _objectSpread(_objectSpread({}, datePickerMessages), {}, {
  placeholder: 'Select time',
  quickSelect: 'Quick select',
  customTime: 'Custom time',
  now: 'Now',
  confirm: 'Confirm'
});

export default messages;